export const userLanguage = navigator?.language || (navigator as any)?.userLanguage;

const dealLangs = () => {
    if (userLanguage === 'zh-TW' || userLanguage === 'zh-CN') {
        return userLanguage
    } else {
        const langsSplit = userLanguage.split('-')
        return langsSplit[0]
    }
}

export const langs = dealLangs()